module.exports = __webpack_public_path__ + "img/arrow-back-black.f7d28fd0.svg";